import { useEffect, useState } from "react";
import { useIntercom } from "react-use-intercom";

import { useProfile } from "app/providers/ProfileProvider";

import useAuth from "./useAuth";

const useInitializeIntercom = () => {
  const [isBooted, setIsBooted] = useState<boolean>();

  const profile = useProfile();
  const isLoggedIn = useAuth();
  const { boot, update, hardShutdown } = useIntercom();

  // Intercom runs as an anonymous visitor: a user id or email is only trusted
  // with a user_hash signed by the server, and the browser must never hold
  // that secret. Identity returns once the API issues the hash.
  useEffect(() => {
    if (profile && !isBooted && isLoggedIn) {
      boot({
        hideDefaultLauncher: true,
      });
      setIsBooted(true);
    }
  }, [boot, isBooted, isLoggedIn, profile]);

  useEffect(() => {
    if (profile && isLoggedIn) {
      update({
        name: `${profile.first_name} ${profile.last_name}`,
        phone: `${profile.phone}`,
      });
    }
  }, [isLoggedIn, profile, update]);

  useEffect(() => {
    if (!profile || !isLoggedIn) {
      hardShutdown();
      setIsBooted(false);
    }
  }, [hardShutdown, isLoggedIn, profile]);

  return { isBooted };
};

export default useInitializeIntercom;
